import { AwardNominationReviewer, AwardNominationReviewerRef } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const assignAwardNominationReviewers: (
  fetchContext: FetchContext,
  awardId: number,
  awardNominationReviewer: AwardNominationReviewer,
  accessToken?: string,
) => Promise<AwardNominationReviewerRef> = (fetchContext, awardId, awardNominationReviewer, accessToken) => fetch(
  `${fetchContext.baseUrl}/api/staff/awards/${awardId}/nomination-reviewers`,
  {
    method: 'POST',
    body: JSON.stringify(awardNominationReviewer),
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  },
).then((response) => responseErrorHandler<AwardNominationReviewerRef>(fetchContext.errorStore, response, 'assign award nomination reviewers'));
